'use client';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Box, Button, Drawer, FormControlLabel, IconButton, MenuItem, Switch, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import useTranslate from '../../../localization/helpers';
var SortDrawer = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, sortDirection = _a.sortDirection, setSortDirection = _a.setSortDirection, sortField = _a.sortField, setSortField = _a.setSortField, sortOptions = _a.sortOptions, onApply = _a.onApply, _c = _a.defaultSortField, defaultSortField = _c === void 0 ? ((_b = sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions[0]) === null || _b === void 0 ? void 0 : _b.value) || '' : _c, _d = _a.backdropColor, backdropColor = _d === void 0 ? 'rgba(0, 0, 0, 0.5)' : _d, folderView = _a.folderView, isSubFolderView = _a.isSubFolderView, setAssetSortPreferenceCallback = _a.setAssetSortPreferenceCallback;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var _e = __read(useState('activeOnTop'), 2), assetSortPreference = _e[0], setAssetSortPreference = _e[1];
    var _f = __read(useState(false), 2), showInactiveAssets = _f[0], setShowInactiveAssets = _f[1];
    useEffect(function () {
        if (open) {
            setSortField('');
        }
    }, [open, setSortField]);
    var handleDirectionChange = function (_, newValue) {
        if (newValue !== null) {
            setSortDirection(newValue);
            setSortField('');
        }
    };
    var handleAssetSortChange = function (_, newValue) {
        if (newValue !== null) {
            setAssetSortPreference(newValue);
            setAssetSortPreferenceCallback && setAssetSortPreferenceCallback(newValue);
        }
    };
    return (_jsxs(Drawer, { open: open, onClose: onClose, anchor: 'bottom', slotProps: {
            backdrop: { style: { backgroundColor: backdropColor } },
            paper: {
                sx: {
                    borderTopLeftRadius: 24,
                    borderTopRightRadius: 24
                }
            }
        }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', padding: '24px 12px 24px 24px', alignItems: 'center', children: [_jsxs(Typography, { variant: 'h6', children: [" ", translate('actions.sortby')] }), _jsx(IconButton, { size: 'small', onClick: onClose, children: _jsx(Icon, { icon: 'mingcute:close-line' }) })] }), _jsxs(Box, { px: '24px', display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Typography, { variant: 'subtitle2', children: translate('actions.sortDirection') }), _jsxs(ToggleButtonGroup, { sx: {
                            my: { xs: 2 },
                            maxHeight: 36,
                            width: { xs: '100%', md: 'auto' }
                        }, exclusive: true, value: sortDirection, onChange: handleDirectionChange, "aria-label": 'sort direction', children: [_jsx(ToggleButton, { size: 'small', value: 'asc', sx: {
                                    borderBottomLeftRadius: '8px !important',
                                    borderTopLeftRadius: '8px !important',
                                    flex: '1 1 auto',
                                    '&.Mui-selected': {
                                        backgroundColor: ' #009983 !important'
                                    }
                                }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Icon, { icon: 'material-symbols:arrow-upward' }), _jsx(Typography, { variant: 'body2', children: translate('actions.ascending') })] }) }), _jsx(ToggleButton, { size: 'small', value: 'desc', sx: {
                                    borderBottomRightRadius: '8px !important',
                                    borderTopRightRadius: '8px !important',
                                    flex: '1 1 auto',
                                    '&.Mui-selected': {
                                        backgroundColor: ' #009983 !important'
                                    }
                                }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Icon, { icon: 'material-symbols:arrow-downward' }), _jsx(Typography, { variant: 'body2', children: translate('actions.descending') })] }) })] }), _jsx(Typography, { variant: 'subtitle2', children: translate('actions.sortField') }), _jsx(Box, { maxHeight: '184px', sx: { overflowY: 'auto' }, children: _jsx(Box, { sx: {
                                borderRadius: '8px',
                                overflow: 'hidden'
                            }, children: sortOptions.map(function (option) { return (_jsxs(MenuItem, { onClick: function () {
                                    setSortField(option.value);
                                    setShowInactiveAssets(false);
                                }, sx: {
                                    py: 1,
                                    borderBottom: option.value !== sortOptions[sortOptions.length - 1].value
                                        ? "1px solid ".concat(theme.palette.divider)
                                        : 'none',
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }, children: [_jsx(Typography, { variant: 'body2', children: option.label }), sortField === option.value && (_jsx(Icon, { icon: 'material-symbols:check', color: theme.palette.primary.main }))] }, option.value)); }) }) })] }), folderView && !isSubFolderView && (_jsxs(Box, { px: '24px', display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(FormControlLabel, { control: _jsx(Switch, { checked: showInactiveAssets, onChange: function (e) {
                                setSortField('');
                                setShowInactiveAssets(e.target.checked);
                            } }), label: translate('common.showInactiveAssets') }), showInactiveAssets && (_jsxs(ToggleButtonGroup, { sx: {
                            my: 1,
                            maxHeight: 36,
                            width: { xs: '100%', md: 'auto' }
                        }, exclusive: true, value: assetSortPreference, onChange: handleAssetSortChange, "aria-label": 'active-inactive sort', children: [_jsx(ToggleButton, { size: 'small', value: 'activeOnTop', sx: {
                                    borderBottomLeftRadius: '8px !important',
                                    borderTopLeftRadius: '8px !important',
                                    flex: '1 1 auto',
                                    '&.Mui-selected': {
                                        backgroundColor: '#009983 !important',
                                        color: 'white'
                                    }
                                }, children: _jsx(Typography, { variant: 'body2', children: translate('common.activeOnTop') }) }), _jsx(ToggleButton, { size: 'small', value: 'inactiveOnTop', sx: {
                                    borderBottomRightRadius: '8px !important',
                                    borderTopRightRadius: '8px !important',
                                    flex: '1 1 auto',
                                    '&.Mui-selected': {
                                        backgroundColor: '#009983 !important',
                                        color: 'white'
                                    }
                                }, children: _jsx(Typography, { variant: 'body2', children: translate('common.inActiveOnTop') }) })] }))] })), _jsxs(Box, { p: '24px', display: 'flex', gap: '12px', justifyContent: 'center', children: [_jsx(Button, { variant: 'outlined', fullWidth: true, color: 'inherit', size: 'medium', onClick: onClose, children: translate('actions.cancel') }), _jsx(Button, { variant: 'contained', fullWidth: true, color: 'inherit', size: 'medium', onClick: onApply, disabled: folderView ? false : !sortField, children: translate('actions.apply') })] })] }));
};
export default SortDrawer;
